/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Zarządzanie listingiem produktów
 *
 * @export
 * @class ListingControler
 * @extends {Filtering}
 */
import { Filtering } from "./Filtering.class"

export class ListingControler extends Filtering {
	constructor(bootstrapObj) {
		super();
		//this.ajaxListingStyleHistory = new Array();
		//this.LSHCurrentIndex = 0;
		this.addToCompareBtns;
		this.removeItemFromCompare;
		this.compareCont;
		this.compareTargetContSelector;
		this.compareTargetCont;
		this.bootstrap = bootstrapObj;
	}
	// ****************************************************************************************************
	// zmiana stylu listingu produktów
	// ****************************************************************************************************
	initListingControlers() {
		var that = this;
		that.initChangeListingStyle();
		that.initSort();
		that.initPagination();
		that.initFiltering();
		that.initProductsPopovers();
		that.initCompare();
		that.initFavorites();
		that.updateListingElementsOrder();
		that.updateListingElementsHeight();
	}
	// ****************************************************************************************************
	// zmiana stylu listingu produktów
	// ****************************************************************************************************
	initChangeListingStyle() {
		var that = this;
		$('.btn-listing').on('click', function () {
			that.loadProductsListing({ listingType: $(this).data('change-listing-type-to') });
		});
	}
	// ****************************************************************************************************
	// zarzadzanie przesunieciem elementow w kafelku listingu w wersji box/lines/mobile
	// ****************************************************************************************************
	updateListingElementsOrder() {
		var that = this;
		var listingStyle = toolsObj.getCookie('productsListingStyle');
		if (listingStyle == 'boxes' && pageObj.settings.bootstrap.kind == 'desktop') {
		//	that.changeListingElementsOrder();
		}
		if (listingStyle == 'boxes' && pageObj.settings.bootstrap.kind == 'mobile') {
		//	that.restoreListingElementsOrder();
		}
	}
	// ****************************************************************************************************
	// przesuniecie elementow w kafelku listingu
	// ****************************************************************************************************
	changeListingElementsOrder() {
//console.log("changeListingElementsOrder");
		var that = this;
		$('.productListingCont').each(function (i, e) {
			// $(e).find('.productPPS').insertAfter($(e).find('.productAvailability')); //  productPrice
			$(e).find('.productPPS').insertAfter($(e).find('.productPrice'));
			$(e).find('.productShipmentCont').insertAfter($(e).find('.productAddToCartPanel'));
		});
	}
	// ****************************************************************************************************
	// przywroceniekolejnosci elementow w kafelku listingu
	// ****************************************************************************************************
	restoreListingElementsOrder() {
//onsole.log("restoreListingElementsOrder");
		var that = this;
		$('.productListingCont').each(function (i, e) {
			$(e).find('h3').prependTo($(e).find('.productInfoPanel'));
			$(e).find('.productCode').prependTo($(this));
			$(e).find('.productPPS').appendTo($(e).find('.productInfoPanel'));
			$(e).find('.productShipmentCont').appendTo($(e).find('.productInfoPanel'));
		});
	}
	// ****************************************************************************************************
	// wyrownanie wysokości elementów w kafelku listingu
	// ****************************************************************************************************
	updateListingElementsHeight() {
		var that = this;
		var listingStyle = toolsObj.getCookie('productsListingStyle');
		if (listingStyle == 'boxes' && pageObj.settings.bootstrap.kind == 'desktop')
			toolsObj.alignElementsHeight('productListingBoxes');
		if (listingStyle == 'boxes' && pageObj.settings.bootstrap.kind == 'mobile')
			toolsObj.resetElementsHeight('productListingBoxes');
	}
	// ****************************************************************************************************
	// Inicjalizacja popovers
	// ****************************************************************************************************
	initProductsPopovers() {
		var that = this;
		that.bootstrap.initPopovers({
			selector: '#productsList .addPopover',
			placement: 'top'
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja dropdowns
	// ****************************************************************************************************
	initProductsDropdowns() {
		var that = this;
		that.bootstrap.initDropdowns({});
	}
}